import React, { useState } from "react";
import './../css/dialogBox.css'
const DialogBox = ({ tchId, open, onClose, onAdd, onReplace}) => {
    if (!open) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" style={{ padding: 40 }} onClick={(e) => e.stopPropagation()}>
                <button type="button" className="btn btn-info text-center " id="closeSlider" onClick={onClose} style={{ right: "-25px", top: "-25px", position: "absolute", opacity: 1 }}>
                    <span id="close" title="Close Slider" className="glyphicon glyphicon-remove" onClick={onClose}></span>
                </button>

                <h2>Choose an Action</h2>
                <div style={{ display: 'flex', width: '100%', gap:"5px", justifyContent: 'space-around', margin: '0 auto', alignItems: 'center' }} >
                    <button className="btn btn-info" onClick={()=>onReplace(tchId)}>Replace Main</button>
                    <button className="btn btn-info" onClick={()=>onAdd(tchId)}>Replace Additional</button>
                    <button type="button" title="Cancel" onClick={onClose} className="btn btn-secondary" style={{outline: '2px solid transparent', outlineOffset: 2,borderColor: 'rgba(102,112,133,.3)'}}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default DialogBox;
